var exports = {
  "kL": "AvatarStack.module__container___WlVJMX",
  "my": "AvatarStack.module__avatar___WlVJMX",
  "KI": "AvatarStack.module__avatarButton___WlVJMX",
  "vn": "AvatarStack.module__avatarContent___WlVJMX",
  "ML": "AvatarStack.module__avatarContextMenuWrap___WlVJMX",
  "hm": "AvatarStack.module__withMask___WlVJMX",
  "i1": "AvatarStack.module__remainingCount___WlVJMX",
};

module.exports = exports;
